import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ygtechnologies/bygr-frontend-component-library';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { Trans } from '@lingui/react/macro';
import { Input } from '@/components/generic-controls';
import { Button } from '@/components/Buttons';
export default class PromptDialog extends React.Component {
    state = { newValue: "" }

    focusElementRef = React.createRef();
    handleOpened = () => {
        this.setState({
            newValue: this.props.value
        }, () => {
            this.focusElementRef.current.focus();
            this.focusElementRef.current.select();
        });
    }

    handleAcceptClick = () => {
        const { onClose, onAccept } = this.props;
        const { newValue } = this.state;

        triggerHandler(onAccept, newValue);
        triggerHandler(onClose);
    }

    handleCancelClick = () => {
        const { onClose, onCancel } = this.props;

        triggerHandler(onCancel);
        triggerHandler(onClose);
    }

    handleChange = e => {
        this.setState({
            newValue: e.target.value
        });
    }


    render() {
        const { title, show } = this.props;
        const { newValue } = this.state;

        return (
            <Modal isOpen={show} toggle={this.handleCancelClick} onOpened={this.handleOpened}>
                <ModalHeader>{title}</ModalHeader>
                <ModalBody>
                    <Input ref={this.focusElementRef} type="text" className="form-control" value={newValue} onChange={this.handleChange} />
                </ModalBody>
                <ModalFooter>
                    <Button color="tertiary" onClick={this.handleCancelClick}><Trans>Cancel</Trans></Button>
                    <Button color="primary" onClick={this.handleAcceptClick}><Trans>Accept</Trans></Button>
                </ModalFooter>
            </Modal>
        );
    }
}